import { useEffect, useState } from 'react';

import { check } from '../lib/auth/guard';
import useUser from './use-user';

export default function useGuard(permissions) {
  const { user } = useUser();
  const [isAllowed, setAllowed] = useState(false);

  useEffect(() => {
    if (user && permissions) {
      setAllowed(check(user.scopes, permissions));
    }
  }, [user, permissions]);

  if (!user) {
    return false;
  }

  return isAllowed;
}
